// /* eslint-disable react-hooks/exhaustive-deps */

import { useAppStore } from "@/store/app";
import { ReactNode, createContext, useContext, useEffect } from "react";
import { Helmet } from "react-helmet-async";

type PresetsContextData = {};

interface PresetsContextProps {
  children: ReactNode;
}

export const PresetsContext = createContext({} as PresetsContextData);

function PresetsProvider({ children }: PresetsContextProps) {
  const { presets, loadPresets } = useAppStore();

  useEffect(() => {
    if (loadPresets) {
      loadPresets();
    }
  }, [loadPresets]);

  function Loading() {
    return <div className="p-3">Loading...</div>;
  }

  return (
    <PresetsContext.Provider value={{}}>
      <Helmet>
        <title>{presets?.theme?.title}</title>
        <meta name="description" content={presets?.theme?.description} />
        <style>
          {`
            body {
              background-color: ${presets?.theme?.colors.background};
              color: ${presets?.theme?.colors.text};
            }
          `}
        </style>
      </Helmet>
      {!presets ? <Loading /> : children}
    </PresetsContext.Provider>
  );
}

function usePresets() {
  const context = useContext(PresetsContext);
  if (context === undefined) {
    throw new Error("usePresets must be used within a PresetsProvider");
  }
  return context;
}

export { PresetsProvider, usePresets };
